import { redoHistory, undoHistory, useHistoryMetaStore } from '@store'
import { useCallback } from 'react'

export function useUndoRedo() {
  const canUndo = useHistoryMetaStore((state) => state.canUndo)
  const canRedo = useHistoryMetaStore((state) => state.canRedo)

  const performUndo = useCallback(() => {
    undoHistory()
  }, [])

  const performRedo = useCallback(() => {
    redoHistory()
  }, [])

  return {
    canUndo,
    canRedo,
    performUndo,
    performRedo,
  }
}
